import { forwardRef } from 'react';

// @ts-ignore
export const TextField = forwardRef(({ name, type, ...props }, ref) => {
  return (
    <input
      ref={ref}
      type={type}
      name={name}
      className={`h-12 mt-4 mb-2 px-5 border border-solid border-black border-opacity-20 rounded-segments-10px placeholder-black placeholder-opacity-30 focus:border-segments-accent-color-1 focus:ring-segments-accent-color-1 disabled:bg-segments-gray w-full`}
      {...props}
    />
  );
});
